<template>
  <a-dropdown overlayClassName="system-change-drop-overlay">
    <span class="right-content__action">
      <icon-font type="gb-icon-moudle" />
      <span style="padding: 0 8px 0 4px">{{ currentName }}</span>
      <a-icon type="down" />
    </span>
    <!-- ** 这里插槽为overlayClassName的子类 -->
    <a-menu slot="overlay" style="top: -4px">
      <a-menu-item
        v-for="system in [...systems.filter(find => systemCode !== find.systemCode && this.isPassSystem(find)), selmuchSystem]"
        :key="system.systemCode"
        @click="toSystem(system)"
      >
        <img :src="sticon[system.systemCode] || sticon['EASY_BOOSTER']">
        {{ system.systemName }}
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { checkSelMuchJump } from '@/api'

export default {
  name: 'SystemChange',
  props: {
    systems: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      sticon: {
        ERP: require('@/assets/ERP.png'),
        SYS_LISTING: require('@/assets/LISTING.png'),
        BI: require('@/assets/BI.png'),
        AMAZON_OPERATE: require('@/assets/AMAZON.png'),
        TMS: require('@/assets/TMS.png'),
        EASY_BOOSTER: require('@/assets/easy.png'),
        M2B: require('@/assets/M2B.png'),
        SELMUCH_ADS: require('@/assets/SELMUCH_ADS.png')
      },
      // 默认写死显示「亿数通广告」系统
      selmuchSystem: {
        systemName: '亿数通广告',
        systemCode: 'SELMUCH_ADS'
      }
    }
  },
  computed: {
    currentName () {
      let found = this.systems.find(item => item.systemCode === this.systemCode)
      return found ? found.systemName : ''
    },
    ...mapGetters([
      'serviceId',
      'systemCode'
    ])
  },
  methods: {
    async toSystem (system) {
      const { systemCode } = system
      const token = this.$ls.get(ACCESS_TOKEN)
      let found = this.systems.find(item => item.systemCode === systemCode)
      console.log('found', found)
      if (!found) {
        if (systemCode === 'SELMUCH_ADS') {
          window.open('/#/company/serve/buy-serve?systemCode=SELMUCH_ADS', '_blank')
        }
        return
      }
      // 系统状态1:初始化2:正常3:停用4:过期9:废弃
      if (found.status === 3) {
        this.$message.warning('当前系统已停用，不支持查看，请联系您的专属销售经理处理')
      } else if (found.status === 9) {
        this.$message.warning('当前系统已废弃，不支持查看，请联系您的专属销售经理处理')
      } else if (found.serviceDeploy <= 2) {
        this.$message.warning('当前系统正在部署中，不支持查看')
      } else if (systemCode === 'SELMUCH_ADS') {
        const { data } = await checkSelMuchJump()
        if (data?.systemUrl) {
          window.open(`${data.systemUrl}/authlogin?token=${token}&resource=sso&module=000`, '_blank')
        }
      } else if (found.embedded === 2) {
        let url = `${found.systemDomain}?token=${token}&resource=sso`
        if (/^(http|https)/.test(url) === false) {
          url = `//${url}`
        }
        window.open(url)
      } else {
        window.open(`/entry/${this.serviceId}/${systemCode}`)
      }
    },
    isPassSystem (system) {
      if (system.systemCode === 'ERP' && system.bundling) {
        return false
      } else if (['EASY_BOOSTER', 'SELMUCH_ADS'].includes(system.systemCode)) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="less">
.system-change-drop-overlay {
  .ant-dropdown-menu {
    overflow: auto;
  }
  .ant-dropdown-menu-item {
    padding: 8px 12px;
    line-height: 20px;
    img {
      display: inline-block;
      vertical-align: top;
      margin-right: 3px;
    }
  }
  &::after{
    position: absolute;
    content: '';
    display: block;
    border: 6px transparent solid;
    border-bottom: 6px #fff solid;
    top: -15px;
    left: 50%;
    margin-left: -10px;
    z-index: 4;
    transition: all 0.1;
  }
}
</style>
<style lang="less" scoped>
.right-content__action {
  position: relative;
  &::after {
    position: absolute;
    display: block;
    content: '';
    border-right: 1px #fff solid;
    height: 14px;
    right: 0px;
    top: 50%;
    margin-top: -7px;
  }
}
</style>
